import defaultConfig from '.';

export default {
  ...defaultConfig,
  publisherdeskLib: 'https://cdn.tpdads.com/configs/pricespy.js',
  loadGDPRScript: true,
};
